import * as React from 'react';

const NotFound = () => {
  return (
    <span>Page which you trying to access is not found!</span>
  );
};

export default NotFound;
